module.exports = __webpack_public_path__ + "img/messages_messages-config-5.248741dc.jpg";